const config = window.microApps || {};

const cachedRemotes = Object.create(null);

async function loadComponent(scope, module) {
	// Initializes the share scope. This fills it with known provided modules from this build and all remotes
	await __webpack_init_sharing__('default');

	// Initialize the container to get shared modules and get the module factory
	const [, factory] = await Promise.all([
		window[scope].init(__webpack_share_scopes__.default),
		window[scope].get(module),
	]);

	return factory().default;
}

function loadRemote(remote) {
	return new Promise((resolve, reject) => {
		if (Object.keys(config).includes(remote)) {
			if (!cachedRemotes[remote]) {
				const element = document.createElement('script');
				element.src = `${config[remote].url}/remoteEntry.js`;
				element.type = 'text/javascript';
				element.async = true;

				element.onload = () => {
					cachedRemotes[remote] = loadComponent(config[remote].scope, `./${remote}`);
					resolve(cachedRemotes[remote]);
				};
				element.onerror = (event, source, lineno, colno, error) => {
					reject(error);
				};

				document.head.appendChild(element);
			} else {
				resolve(cachedRemotes[remote]);
			}
		} else {
			reject(new Error('Invalid remote'));
		}
	});
}

export { loadRemote };
